<template>
  <div>
    <v-container style="max-width: 1200px">
      <v-row style="min-height: 80vh" justify="center" align="center" dense>
        <v-col
          cols="12"
          sm="6"
          md="6"
          v-for="item in CardList"
          :key="item.id"
          :lg="item.col"
          class="d-flex justify-center"
        >
          <v-hover v-slot="{ hover }" class="w-100">
            <v-card
              :elevation="hover ? 15 : 3"
              class="rounded-lg transition-smooth"
              style="width: 100%; cursor: pointer"
            >
              <v-img
                :src="item.src"
                class="white--text align-end rounded-lg"
                height="400px"
                @click="NavigatePage(item.key)"
              >
                <div class="gradient-overlay"></div>
                <v-card-title class="menu-title">
                  {{ $t(item.nameKey) }}
                </v-card-title>
              </v-img>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium">
          Loading, please wait...
        </span>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import enurl from "@/api/environment";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";

const MENU_IMAGES = Object.freeze({
  myQRParking: require("@/assets/QR.jpg"),
  preRegisterParking: require("@/assets/preregister.jpg"),
  preRegisterParkingWalkin: require("@/assets/Walk in.jpg"),
  managePreRegisterParking: require("@/assets/Manage-Pre.jpg"),
});

export default {
  name: "MainMenu",
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      menu: {},
      menuConfig: [
        {
          key: "myQRParking",
          src: MENU_IMAGES.myQRParking,
          nameKey: "message.MyQR",
          id: 1,
        },
        {
          key: "preRegisterParking",
          src: MENU_IMAGES.preRegisterParking,
          nameKey: "message.PreRegisterParking",
          id: 2,
        },
        {
          key: "preRegisterParkingWalkin",
          src: MENU_IMAGES.preRegisterParkingWalkin,
          nameKey: "message.WalkIn",
          id: 3,
        },
        {
          key: "managePreRegisterParking",
          src: MENU_IMAGES.managePreRegisterParking,
          nameKey: "message.ManagePreRegister",
          id: 4,
        },
      ],
    };
  },

  computed: {
    CardList() {
      return this.menuConfig
        .filter((m) => this.menu[m.key] === true)
        .map((m) => ({
          ...m,
          col: 3,
        }));
    },
  },

  mounted() {
    this.getDataMenuPermission();
  },

  methods: {
    getDataMenuPermission() {
      this.LoadingDialog = true;
      axios
        .get(`${this.url}Permission/getDataMenuPermission`)
        .then((response) => {
          if (response.data.status !== 0) return;
          this.menu = response.data.data;
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          this.LoadingDialog = false;
        });
    },

    NavigatePage(key) {
      switch (key) {
        case "myQRParking":
          this.$router.push("/MyQRParking");
          break;
        case "preRegisterParking":
          this.$router.push("/PreRegisterParking");
          break;
        case "preRegisterParkingWalkin":
          this.$router.push("/WalkInParking");
          break;
        case "managePreRegisterParking":
          this.$router.push("/ManagePreRegisterParking");
          break;
      }
    },

    changeLang(lang) {
      this.$i18n.locale = lang;
    },
  },
};
</script>

<style scoped>
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.TitleCSS {
  font-size: 18px;
  font-weight: 300;
  color: black;
}
@font-face {
  font-family: "Roboto", sans-serif;
  src: local("English"), url(../assets/Font/Kanit-Regular.ttf);
}
* >>> .v-data-table-header {
  background-color: #333333 !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.transition-smooth {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.v-card:hover {
  transform: translateY(-8px);
}

.gradient-overlay {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 40%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
  border-radius: 0 0 12px 12px;
}

.menu-title {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.9);

  /* ทำให้เหลือแค่ 1 บรรทัด */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; /* ถ้ายาวเกินจะแสดง ... */
  max-width: 90%; /* กันไม่ให้เกินกรอบ */
}
</style>
